import {GanttDefaultAppSettings} from "../@types";
import {SystemStatusGroup} from "../../../gd/const/system-status";
import {FIELDS} from "../../../gd/const/fields/fields";

// type = GanttDefaultAppSettings





export const GANTT_DEFAULT_SETTINGS: GanttDefaultAppSettings = {
    // columns                 : _.map([
    //     gd.const.fields[gd.const.fields.type.TITLE].columnId,
    //     gd.const.fields[gd.const.fields.type.DURATION_WORK_DAYS].columnId,
    //     gd.const.fields[gd.const.fields.type.START_END_DATE].columnId
    // ], id=>({id: id/*, aggregate: null*/})),

    columns                 : _.map([
        // @ts-ignore
        FIELDS[FIELDS.type.TITLE].columnId,
        // @ts-ignore
        FIELDS[FIELDS.type.DURATION_WORK_DAYS].columnId,
        // @ts-ignore
        FIELDS[FIELDS.type.START_END_DATE].columnId
    ], id=>({id: id/*, aggregate: null*/})),

    systemStatusFilter      : SystemStatusGroup.OPEN,
    zoom                    : 0.67,
    showCriticalPath        : false,
    sortBy                  : null,  // current sort by column value
    filters                 : {},
    areEmptyFoldersHidden   : false,
    displayProgress         : true,

    taskItemColorFieldId    : 'statusId',
    projectItemColorFieldId : null,
    eventItemColorFieldId   : 'isAccomplished',

    itemIcons               : [2,3] //ITEM_TYPE_PROJECT (EntityType.PROJECT), ITEM_TYPE_EVENT (EntityType.EVENT)
}
